/**
 * Created by liux on 18/3/21.
 * @param get name ,set name value ,clear name
 * @return value or undefined
 */
var hasSession = true;
var storage = window.sessionStorage;
import {parse} from './utils'
if (storage) {
  try {
    storage.setItem('_sessionStorageTest', 'Hello World!');
    storage.removeItem('_sessionStorageTest');
  } catch (e) {
    hasSession = false;
  }
} else {
  hasSession = false;
}

function getSession(name) {
  if(!hasSession){
    alert('请关闭无痕（隐身）模式或者换个浏览器尝试打开')
    return ''
  }
  return parse(storage.getItem(name));
};
function setSession(name, val) {
  if(!hasSession){
    return ''
  }
  storage.setItem(name, JSON.stringify(val));
};
function clearSession(name) {
  if(!hasSession){
    return ''
  }
  setSession(name, '');
}

export {
  getSession,
  setSession,
  clearSession,
};

